export function setupModalToggles(): void {
    const toggles = document.querySelectorAll('[data-toggle="modal"]');

    toggles.forEach((toggle) => {
        toggle.insertAdjacentHTML('beforeend', '<span class="sr-only"> will open a modal.</span>');
    });
}
